import { clearSystemAccess } from './systemAccess';

export const LOGIN_SESSION_EXPIRED = 'login-session-expired';

// Ignore late failures belonging to a previous login. In particular, a failed
// background request must never clear a newly signed-in user's credentials.
export function clearExpiredLogin(authorization: string | undefined): boolean {
  const current = localStorage.getItem('token');
  if (!current || authorization !== `Bearer ${current}`) return false;
  localStorage.removeItem('token');
  clearSystemAccess();
  window.dispatchEvent(new Event(LOGIN_SESSION_EXPIRED));
  return true;
}

export function redirectToLogin() {
  if (window.location.pathname !== '/user/login') window.location.replace('/user/login');
}
